import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useMemo } from 'react';
import { getLiquidityOverviewActivated } from '../../../app/api/generated/client';
import { queryKeys } from '../query-keys';

// todo: (liquidity-activated) remove once feature is stable and officially released
export function useLiquidityOverviewActivated(): UseQueryResult<boolean, AxiosError> {
    const queryKey = useMemo(() => queryKeys.liquidityOverviewActivated(), []);

    return useQuery({
        queryKey,
        queryFn: ({ signal }) => getLiquidityOverviewActivated({ signal }).then((result) => result.data),
    });
}
